// extracted by css-extract-rspack-plugin
export default {"cls1":"PaperSelector-cls1_14_","cls2":"PaperSelector-cls2_6cB PaperSelector-cls1_14_"};